import { useContext } from 'react';

import {
  TimelineContext,
  useTimelineEventContext,
} from '@components/patterns/Timeline/context';
import {
  Ago,
  Timestamp,
  TimestampFormat,
} from '@components/primitives/Timestamp';

import css from './styles.module.css';

export interface TimelineTimestampProps {
  /**
   * Optional so a caller can pass a value that may not have arrived yet
   * without guarding at every call site.
   */
  value?: string | number | Date;
  /** Overrides the format set on the root timeline. */
  format?: TimestampFormat;
}

/**
 * When the event happened. Falls back to a relative time when neither this
 * nor the root timeline sets a format.
 */
export function TimelineTimestamp({
  value,
  format: formatProp,
}: TimelineTimestampProps) {
  const { timestampFormat } = useContext(TimelineContext);
  const { variant } = useTimelineEventContext();

  const format = formatProp ?? timestampFormat;

  // A pending event has not happened yet, so it has nothing to stamp.
  if (!value || variant === 'pending') return null;

  return (
    <p className={css.timestamp}>
      {format ? (
        <Timestamp value={value} format={format} side="right" delay={200} />
      ) : (
        <Ago value={value} side="right" delay={200} />
      )}
    </p>
  );
}
